<template>
    <div class="el-main-wrapper">
        <el-row class="el-title-block">
            <h1 class="el-title-with-icon">
                {{ $t('title.inventory') }}
                <span v-if="selectedContainer"
                >: {{ selectedContainer.Description }}</span
                >
            </h1>
        </el-row>
        <el-row>
            <stc-inventory-list></stc-inventory-list>
        </el-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InventoryListVue from '../../components/inventory/InventoryList.vue'

export default {
    name: 'inventory-view',

    components: {
        'stc-inventory-list': InventoryListVue,
    },

    computed: mapGetters(['selectedContainer']),
}
</script>
